export enum DecorID {
    // Large Items (9-Slice)
    RugRed = 'rug_red',
    RugGreen = 'rug_green',
    RugIce = 'rug_ice',
    FloorOrnate = 'floor_ornate',
    FloorBlue = 'floor_blue',
    BorderGold = 'border_gold',
    FloorChecker = 'floor_checker',
    FloorBlue2 = 'floor_blue_2',
    IceSheet = 'ice_sheet',
    SnowPatch = 'snow_patch',
    RuneRed = 'rune_red',
    IceCracked = 'ice_cracked',
    RuneRed2 = 'rune_red_2',
    MagicCircle = 'magic_circle',
    VoidHole = 'void_hole',

    // Small Decor - Furniture
    WindowLit = 'window_lit',
    WindowDark = 'window_dark',
    BookshelfFullSnow = 'bookshelf_full_snow',
    BookshelfEmptySnow = 'bookshelf_empty_snow',
    TableRoundSnow = 'table_round_snow',
    TableRectSnow = 'table_rect_snow',
    ChairFrontSnow = 'chair_front_snow',
    ChairBackSnow = 'chair_back_snow',
    BedHead = 'bed_head',
    BedFoot = 'bed_foot',
    TableRound = 'table_round',
    TableRect = 'table_rect',
    ChairFront = 'chair_front',
    ChairBack = 'chair_back',
    BookshelfCommon = 'bookshelf_common',
    Cabinet = 'cabinet',

    // Small Decor - Nature
    RockSnow = 'rock_snow',
    BushFrozen = 'bush_frozen',
    TreePineSmall = 'tree_pine_small',
    TreeDeadSmall = 'tree_dead_small',
    SnowmanProp = 'snowman_prop',
    IceCrystalSnow = 'ice_crystal_snow',
    SnowMound = 'snow_mound',
    LogPileSnow = 'log_pile_snow',
    RockCommon = 'rock_common',
    BushCommon = 'bush_common',
    TreePineCommon = 'tree_pine_common',
    TreeDeadCommon = 'tree_dead_common',
    CrystalCommon = 'crystal_common',
    MoundCommon = 'mound_common',
    LogPileCommon = 'log_pile_common',
    FenceCommon = 'fence_common',

    // Small Decor - Fences/Walls
    FenceH = 'fence_h',
    FenceV = 'fence_v',
    FenceCorner = 'fence_corner',
    FencePost = 'fence_post',
    WallStoneLow = 'wall_stone_low',
    WallIceLow = 'wall_ice_low',
    HedgeSnow = 'hedge_snow',
    GateDecor = 'gate_decor',

    // Small Decor - Clutter/Items
    CrateSnow = 'crate_snow',
    BarrelSnow = 'barrel_snow',
    SackSnow = 'sack_snow',
    PotSnow = 'pot_snow',
    LanternGround = 'lantern_ground',
    WoodPile = 'wood_pile',
    BucketSnow = 'bucket_snow',
    ShovelSnow = 'shovel_snow',
    Painting = 'painting',
    Mirror = 'mirror',
    Clock = 'clock',
    Vase = 'vase',
    CrateCommon = 'crate_common',
    BarrelCommon = 'barrel_common',
    SackCommon = 'sack_common',
    CandleStand = 'candle_stand',

    // Small Decor - Holiday
    TreeXmas = 'tree_xmas',
    SnowmanCommon = 'snowman_common',
    Wreath = 'wreath',
    StockingDecor = 'stocking_decor',
    GiftRed = 'gift_red',
    GiftGreen = 'gift_green',
    Garland = 'garland',
    Mistletoe = 'mistletoe',
    
    // Special
    ArmorStand = 'armor_stand',
    WeaponRack = 'weapon_rack',
    BonePile = 'bone_pile',

    // Lighting
    Torch = 'torch',
    Brazier = 'brazier',
    Streetlamp = 'streetlamp',

    // Wall Items
    BannerRed = 'banner_red',
    BannerBlue = 'banner_blue',
    ShieldDecor = 'shield_decor',

    // Corridor/Dungeon
    Cobweb = 'cobweb',
    Rubble = 'rubble'
}
